
import { CSSProperties, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import UsuarioService, { UsuarioInput, getCategoriaIndexByName } from '../../../services/UsuarioService';
import Voltar from '../../../components/voltar/voltar';
import UsuarioForm from '../usuario-formulario/usuario-formulario';
import ErroDeNegocio from '../../../errors/ErroDeNegocio';
import useAppFeedback from '../../../hooks/use-app-feedback';
import Modal from '../../../components/modal/modal';
import Button from '../../../components/button/button';

const styles: { [key: string]: CSSProperties } = {
  notificacao: {
    width: '400px',
    background: '#fff',
    color: '#6C7381',
    borderRadius: '12px',
  },
  h4: { margin: 0 }
};

const UsuarioCriacao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { adicionarFeedbackDeErro, limparFeedbacks } = useAppFeedback();
  const [isOpened, setIsOpened] = useState(false);

  const criaNovoUsuario = useCallback((async (usuario: UsuarioInput): Promise<boolean> => {

    limparFeedbacks();
    setLoading(true)
    let result = true;

    if (usuario.areaLiberadas.length === 0) {
      setIsOpened(true);
      setLoading(false);
      return false;
    }

    try {
      usuario.categoria = getCategoriaIndexByName(usuario.categoria)
      await UsuarioService.salvarUsuario(usuario);
      navigate('/usuario', { state: { result: 'Usuario criado com sucesso' } });
    } catch (error) {
      const message = (error as ErroDeNegocio)?.mensagem || (error as Error).message;
      adicionarFeedbackDeErro(message);
      result = false;
    }
    setLoading(false)
    return result;
  }), [adicionarFeedbackDeErro, limparFeedbacks, navigate])

  const voltar = useCallback(() => {
    limparFeedbacks();
    navigate('/usuario')
  }, [limparFeedbacks, navigate]);

  return (
    <>
      <h1 className="top-title"><Voltar caminho='usuario' />Novo Usuario</h1>
      <UsuarioForm
        loading={loading}
        titulo='Novo Usuario'
        acao={{
          onClickAcao: criaNovoUsuario,
          texto: "Criar Usuario"
        }}
        cancelarAcao={{
          onClickCancelaAcao: voltar,
          texto: 'Cancelar'
        }}
      />
      <Modal isOpened={isOpened}>
        <>
          
            <div style={styles.notificacao}>
              <h2><strong>Quase lá.</strong></h2>
              <h4 style={styles.h4}>                               
                Escolha quais painéis e áreas este usuário poderá <br /> 
                visualizar em definir acessos para garantir a <br /> 
                segurança dos dados. <br />  <br /> 
              </h4>
              <Button  
                classes='formulario__button'
                text="Entendi" onClick={() => setIsOpened(false)} />
            </div>
        </>
      </Modal>
    </>
  );
}
export default UsuarioCriacao;

